import { DataConverter } from "../../../Global/Base/Converters/DataConverter";
import { IComparable } from "../../../Global/Base/IComparable";
import { BigIntOps } from "./BigIntOps";

export class OWUint64 implements IComparable {
    private readonly _data: Uint8Array;

    constructor(data: Uint8Array) {
        this._data = data;
    }

    public static fromBase64(data: string): OWUint64 {
        return new OWUint64(DataConverter.base64ToArray(data));
    }

    // Uint64
    // QCRlgY+pVKs=
    // 12345678912345678912
    // AQAAAA8AAPA=
    // 17293822633527214081

    // vrací číslo převedené do typu Number
    // je nutné počítat se ztrátou přesnosti
    public toNumber(): number {
        const dw = new DataView(this._data.buffer);
        const lo = dw.getUint32(0, true);
        const hi = dw.getUint32(4, true);
        return hi * 0x100000000 + lo;
    }

    public toString(): string {
        return BigIntOps.bigUIntToString(this._data);
    }

    public compare(value2: any): boolean {
        if (value2 instanceof OWUint64) {
            if (this._data.byteLength !== value2._data.byteLength) {
                return false;
            }

            for (let i = 0; i !== this._data.byteLength; i++) {
                if (this._data[i] !== value2._data[i]) {
                    return false;
                }
            }
            return true;
        }
        return false;
    }
}
